import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      borderRadius: 4,
      border: `1px solid ${theme.palette.divider}`,
      padding: "18px 24px 22px",
      boxSizing: "border-box",
      marginTop: 16,
      fontFamily: theme.typography.fontFamily,
      direction: "rtl",
    },

    title: {
      color: theme.palette.secondary.main,
      fontSize: "15px !important",
      fontWeight: "500 !important",
      fontFamily: `${theme.typography.fontFamily} !important`,
      textAlign: "right",
      marginBottom: "12px !important",
    },

    list: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
    },

    rowCard: {
      minHeight: 58,
      display: "grid",
      gridTemplateColumns: "minmax(280px, 1.4fr) minmax(620px, 2fr)",
      alignItems: "center",
      gap: 24,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 4,
      backgroundColor: theme.palette.background.paper,
      padding: "8px 14px",
      boxSizing: "border-box",
    },

    parameterCell: {
      minWidth: 0,
      textAlign: "right",
    },

    fieldLabel: {
      color: theme.palette.text.primary,
      fontSize: "12px !important",
      fontWeight: "400 !important",
      fontFamily: `${theme.typography.fontFamily} !important`,
      lineHeight: "16px !important",
      whiteSpace: "nowrap",
    },

    parameterValue: {
      marginTop: "4px !important",
      color: theme.palette.secondary.main,
      fontSize: "13px !important",
      fontWeight: "500 !important",
      fontFamily: `${theme.typography.fontFamily} !important`,
      lineHeight: "18px !important",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    valuesGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(7, minmax(72px, 1fr))",
      gap: 12,
      alignItems: "center",
      direction: "rtl",
    },

    valueCell: {
      minWidth: 0,
      textAlign: "center",
    },

    fieldValue: {
      marginTop: "4px !important",
      color: theme.palette.secondary.main,
      fontSize: "13px !important",
      fontWeight: "400 !important",
      fontFamily: `${theme.typography.fontFamily} !important`,
      lineHeight: "18px !important",
      whiteSpace: "nowrap",
    },

    greenValue: {
      marginTop: "4px !important",
      color: theme.palette.success.main,
      fontSize: "13px !important",
      fontWeight: "500 !important",
      fontFamily: `${theme.typography.fontFamily} !important`,
      lineHeight: "18px !important",
      whiteSpace: "nowrap",
    },

    "@media (max-width: 1200px)": {
      rowCard: {
        gridTemplateColumns: "1fr",
        gap: 12,
      },

      valuesGrid: {
        gridTemplateColumns: "repeat(4, minmax(80px, 1fr))",
      },
    },

    "@media (max-width: 800px)": {
      valuesGrid: {
        gridTemplateColumns: "repeat(2, minmax(80px, 1fr))",
      },
    },
  })
);